import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { BreadcrumbService, BreadcrumbUrls } from '../../../providers/services/breadcrumb.service';
import { PathNames, Paths } from '../../../../config/config';
import { UtilsService } from '../../../providers/services/utils.service';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import {Response} from 'express';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {

  public readonly title = PathNames[Paths.NotFound];

  constructor(private utilsService: UtilsService, private breadcrumbService: BreadcrumbService,
              @Optional() @Inject(RESPONSE) private response: Response) {
    this.breadcrumbService.next(
      BreadcrumbUrls.instance
        .addUrl({ label: PathNames[Paths.NotFound], link: Paths.NotFound })
    );
  }

  ngOnInit() {
    if (!this.utilsService.isPlatformBrowser) {
      this.response.status(404);
    }
  }

  ngOnDestroy(): void {
    this.breadcrumbService.reset();
  }

}
